import React, { useState } from "react";
import { useTranslation } from "../../i18n";
import "./CookieBanner.css"; 

const CookieBanner = () => {
    const { t } = useTranslation();
    // Estado inicial basado en localStorage
    const [showBanner, setShowBanner] = useState(() => {
        return localStorage.getItem("cookiesAccepted") !== "true";
    });

    const acceptCookies = () => {
        localStorage.setItem("cookiesAccepted", "true");
        setShowBanner(false);
    };

    return (
        showBanner && (
            <div className="cookie-banner">
                <p translate="no">
                    {t("cookies.message")}{" "}
                    <a href="/cookies-policy">{t("cookies.link")}</a>.
                </p>
                <button onClick={acceptCookies}>{t("cookies.accept")}</button>
            </div>
        )
    );
};

export default CookieBanner;
